import { render } from "./WechatPay.vue?vue&type=template&id=66873b00"
import script from "./WechatPay.vue?vue&type=script&lang=js"
export * from "./WechatPay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__